import { render, staticRenderFns } from "./channelSdkConfig.vue?vue&type=template&id=5e4c96e8&scoped=true"
import script from "./channelSdkConfig.vue?vue&type=script&lang=js"
export * from "./channelSdkConfig.vue?vue&type=script&lang=js"
import style0 from "./channelSdkConfig.vue?vue&type=style&index=0&id=5e4c96e8&scoped=true&lang=scss"
import style1 from "./channelSdkConfig.vue?vue&type=style&index=1&id=5e4c96e8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c96e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e4c96e8')) {
      api.createRecord('5e4c96e8', component.options)
    } else {
      api.reload('5e4c96e8', component.options)
    }
    module.hot.accept("./channelSdkConfig.vue?vue&type=template&id=5e4c96e8&scoped=true", function () {
      api.rerender('5e4c96e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/channelSdkConfig/channelSdkConfig.vue"
export default component.exports